<template>
    <div class="app text-center">
        <v-dialog
        persistent
        v-model="show"
        :width="width ?? 400">
        <v-card>
            <v-card-title class="text-h5 primary white--text">{{ $t('showmessage.title') }}</v-card-title>

            <v-card-text class="pa-5 text-center font-weight-bold">{{ msg }}</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="onOkClick" width="100">{{ $t('showmessage.ok_button') }}</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: "ShowMessage",
  methods: {
    onOkClick() {
      this.show = false;
      if (this.callBack != null) {
        this.callBack();
      }
    }
  },
  props: {
     value: Boolean,
     msg: String,
     width: Number,
     callBack: null
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },
};
</script>